<proffeo-ui-dialog [title]="'edit-user-title' | translate">
  <form
    [formRoot]="form"
    autocomplete="off"
    class="flex flex-col w-full gap-4"
  >
    <proffeo-ui-input
      [formField]="form.email"
      label="placeholders.e-mail"
      prefixIcon="alternate_email"
      class="w-full"
    />

    <proffeo-ui-input
      [formField]="form.firstName"
      label="placeholders.first-name"
      prefixIcon="account_box"
      class="w-full"
    />

    <proffeo-ui-input
      [formField]="form.lastName"
      label="placeholders.last-name"
      prefixIcon="account_box"
      class="w-full"
    />

    <proffeo-ui-input
      [formField]="form.notes"
      label="placeholders.notes"
      prefixIcon="comment"
      class="w-full"
    />

    <proffeo-ui-input
      [formField]="form.address"
      label="placeholders.address"
      prefixIcon="location_on"
      class="w-full"
    />

    <proffeo-ui-input
      [formField]="form.phoneNumbers"
      label="placeholders.phone-number"
      prefixIcon="phone"
      class="w-full"
    />
  </form>
  <div
    dialog-actions
    class="flex w-full justify-end gap-2"
  >
    <proffeo-ui-button
      text="close"
      matDialogClose
    ></proffeo-ui-button>
    <proffeo-ui-button
      (clicked)="saveUser()"
      [disabled]="form().submitting()"
      variant="accent"
      text="save-and-close"
    ></proffeo-ui-button>
  </div>
</proffeo-ui-dialog>
